import React from 'react';

import Price from '../Layouts/MainPart/Price/Price';

function PriceCalculationPage() {
	return (
		<div>
			<Price />
		</div>
	);
}

export default PriceCalculationPage;
